import React, { useEffect, useRef, useState } from "react";
import styles from "./GuestList.module.css";
import {
  Box,
  InputField,
  SearchInput,
  SubmitButton,
  TextComponent,
} from "../../../../components";
import { BsFillFilterSquareFill } from "react-icons/bs";
import { List, Skeleton } from "antd";
import Modal from "../../../../components/modal/Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { EventPlanningMiddleware } from "../../../../Store/Middlewares/EventPlanningMiddleware";
import { showAlert } from "../../../../Store/Actions/GeneralActions";
import { FiDelete } from "react-icons/fi";
import { MdDelete } from "react-icons/md";

const StarIcon = () => {
  return (
    <svg
      viewBox="0 0 66 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svgIcon}
    >
      <path
        className={styles.svgIconPath}
        d="M21.191 5.75298H3M12.0955 48.1986H3M6.03183 26.9758H3M43.5962 6.38967L47.8711 14.9394C48.4471 16.1218 49.9934 17.2436 51.297 17.4862L59.0282 18.7595C63.9701 19.5781 65.1222 23.1557 61.5749 26.7332L55.5416 32.7666C54.5411 33.7671 53.9651 35.7378 54.2986 37.1627L56.0267 44.621C57.391 50.5028 54.2379 52.807 49.0535 49.7145L41.8074 45.4093C40.5037 44.621 38.3208 44.621 37.0171 45.4093L29.7711 49.7145C24.5866 52.7767 21.4335 50.5028 22.7978 44.621L24.526 37.1627C24.8595 35.7681 24.2834 33.7974 23.2829 32.7666L17.2496 26.7332C13.7024 23.186 14.8545 19.6084 19.7963 18.7595L27.5275 17.4862C28.8312 17.2739 30.3774 16.1218 30.9535 14.9394L35.2283 6.38967C37.5022 1.75097 41.2617 1.75097 43.5962 6.38967Z"
        stroke-width="4.71575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const PersonIcon = () => {
  return (
    <svg
      viewBox="0 0 52 59"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={styles.svgIcon}
    >
      <path
        d="M21.4409 3.22916L7.99219 8.26904C4.89279 9.42794 2.35938 13.0933 2.35938 16.4083V36.4331C2.35938 39.6133 4.46157 43.7908 7.02194 45.7043L18.611 54.3557C22.4111 57.2125 28.6638 57.2125 32.4639 54.3557L44.053 45.7043C46.6133 43.7908 48.7155 39.6133 48.7155 36.4331V16.4083C48.7155 13.0933 46.1821 9.42794 43.0827 8.26904L29.634 3.22916C27.3432 2.39367 23.6778 2.39367 21.4409 3.22916Z"
        className={styles.svgIconPath}
        stroke-width="4.71575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M25.5069 26.6489H25.1565C22.6231 26.5681 20.6018 24.4659 20.6018 21.9055C20.6018 19.2913 22.7309 17.1621 25.3452 17.1621C27.9595 17.1621 30.0886 19.2913 30.0886 21.9055C30.0617 24.4928 28.0403 26.5681 25.5069 26.6489ZM20.1436 34.1953C17.5563 35.9202 17.5563 38.7501 20.1436 40.4749C23.0813 42.4424 27.9056 42.4424 30.8433 40.4749C33.4306 38.7501 33.4306 35.9202 30.8433 34.1953C27.9325 32.2279 23.1083 32.2279 20.1436 34.1953Z"
        className={styles.svgIconPath}
        stroke-width="4.71575"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

const GuestList = () => {
  const GuestList = useSelector(
    (state) => state.EventPlanningReducer.GuestList
  );
  const eventDetails = useSelector((state) => state.EventReducer.EventDetails);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setloading] = useState(true);

  const searchRef = useRef();

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventPlanningMiddleware.getGuests({ id: eventDetails?.id })).then(
      () => {
        setloading(false);
      }
    );
  }, []);

  const onSearch = (name) => {
    clearTimeout(searchRef.current);
    searchRef.current = setTimeout(() => {
      setloading(true);
      dispatch(
        EventPlanningMiddleware.getGuests({ id: eventDetails?.id, name })
      ).then(() => {
        setloading(false);
      });
    }, 500);
  };

  console.log(GuestList);

  const deleteGuest = (id) => {
    setloading(true);
    dispatch(
      EventPlanningMiddleware.deleteEventGuests({
        event_id: eventDetails?.id,
        id,
      })
    ).then(() => {
      setloading(false);
    });
  };

  const renderItem = (item, index) => {
    return (
      <div className={styles.listItem} key={item.id}>
        <TextComponent text={item?.name} textClass={styles.listname} />
        <div className={styles.iconCont}>
          <TextComponent
            text={item?.status == "rsvp_sent" || item?.status == "confirmed" ? "Sent" : null}
            textClass={styles.liststatus}
          />
          {(item?.status == "pending" || item?.status == "not_attending") && (
            <MdDelete
              size={25}
              color="var(--primary-color)"
              cursor="pointer"
              onClick={() => deleteGuest(item.id)}
            />
          )}
        </div>
      </div>
    );
  };
  return (
    <div className={styles.mainCont}>
      <Box boxClass={styles.header}>
        <div className={styles.h_left}>
          <div className={styles.l_Left}>
            <StarIcon />
          </div>
          <div className={styles.l_Right}>
            <div className={styles.tabBtn}>
              <TextComponent
                text={GuestList?.stats?.attending}
                textClass={styles.BtnNum}
              />
              <TextComponent text={"Attending"} textClass={styles.BtnText} />
            </div>
            <div
              className={styles.tabBtn}
              onClick={() => {
                navigate("/events/guestDetails/pending", {
                  state: { headrTitle: "Pending Guest" },
                });
              }}
            >
              <TextComponent
                text={GuestList?.stats?.pending}
                textClass={styles.BtnNum}
              />
              <TextComponent text={"Pending"} textClass={styles.BtnText} />
            </div>
          </div>
        </div>
        <div className={styles.h_right}>
          <div className={styles.r_left}>
            <PersonIcon />
          </div>
          <div className={styles.r_right}>
            <TextComponent
              text={GuestList?.stats?.assigned_table}
              textClass={styles.BtnNum}
            />
            <TextComponent text={"Assigned Table"} textClass={styles.BtnText} />
          </div>
        </div>
      </Box>
      <div className={styles.searchDiv}>
        <div className={styles.search}>
          <SearchInput
            placeholder={"Search"}
            onChange={(e) => onSearch(e.target.value)}
            // rightIcon={
            //   <BsFillFilterSquareFill size={25} className={styles.filterIcon} />
            // }
          />
        </div>
        <div className={styles.AG_btnDiv}>
          <SubmitButton
            title="Add Guest"
            onClick={() => {
              setIsModalOpen(true);
            }}
            btnClass={styles.addGuestBtn}
          />
        </div>
      </div>
      <div className={styles.header2}>
        <TextComponent text={"Guests"} textClass={styles.header2Text} />
        {/* <TextComponent text={"View more"} textClass={styles.viewMore} /> */}
      </div>
      <Skeleton loading={loading}>
        <List
          dataSource={GuestList?.guests?.length > 0 ? GuestList?.guests : []}
          renderItem={renderItem}
          className={styles.list}
        />
      </Skeleton>
      {isModalOpen && (
        <AddGuestModal
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
        />
      )}
    </div>
  );
};

const AddGuestModal = ({ isModalOpen, setIsModalOpen }) => {
  const eventDetails = useSelector((state) => state.EventReducer.EventDetails);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");

  const dispatch = useDispatch();

  const submit = () => {
    if (!firstName || !lastName || !email) {
      dispatch(
        showAlert({
          title: "Add Guest",
          message: "All fields are mandatory!",
          type: "Error",
          status: 400,
        })
      );
      return;
    } else if (
      /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(email) == false
    ) {
      dispatch(
        showAlert({
          title: "Invalid Email!",
          type: "error",
          message:
            "Please enter a valid email address in the correct format (e.g example@example.com)",
        })
      );
      return;
    } else {
      let data = {
        first_name: firstName,
        last_name: lastName,
        email: email,
        event_id: eventDetails?.id,
      };

      dispatch(EventPlanningMiddleware.createGuest(data))
        .then(() => setIsModalOpen(false))
        .catch(() => setIsModalOpen(false));
    }
  };
  return (
    <Modal
      isModalOpen={isModalOpen}
      setIsModalOpen={setIsModalOpen}
      closable={true}
      // pinkBg={true}
      className={styles.modal}
    >
      <div className={styles.modalDiv}>
        <TextComponent text={"Personal info"} textClass={styles.modalHeader} />
        <InputField
          styles={styles.input}
          placeholder={"First name"}
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
        <InputField
          styles={styles.input}
          placeholder={"Last name"}
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
        <InputField
          styles={styles.inputBottom}
          placeholder={"Email"}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <SubmitButton
          title="Add Guest"
          btnClass={styles.modalBtn}
          onClick={submit}
        />
      </div>
    </Modal>
  );
};

export default GuestList;
